/** Category-based placeholder images for vendor directory cards and heroes. */

const CATEGORY_PLACEHOLDER_SLUGS = [
  'uniforms-apparel',
  'duty-gear',
  'firearms-accessories',
  'body-armor',
  'training-equipment',
  'k9-supplies',
  'vehicles-fleet',
  'software-technology',
  'communications',
  'forensics-investigation',
  'medical-first-aid',
  'facility-security',
  'books-training-aids',
  'badges-insignia',
  'footwear',
  'generic',
] as const;

export type VendorCategoryPlaceholderSlug = (typeof CATEGORY_PLACEHOLDER_SLUGS)[number];

export const VENDOR_DIRECTORY_GENERIC_PLACEHOLDER = '/images/vendors/placeholders/generic.svg';

export function getVendorCategoryPlaceholder(categorySlug?: string | null): string {
  if (!categorySlug) return VENDOR_DIRECTORY_GENERIC_PLACEHOLDER;
  if ((CATEGORY_PLACEHOLDER_SLUGS as readonly string[]).includes(categorySlug)) {
    return `/images/vendors/placeholders/${categorySlug}.svg`;
  }
  return VENDOR_DIRECTORY_GENERIC_PLACEHOLDER;
}

export function getVendorCategoryPlaceholderFromIds(
  categoryIds: number[] | undefined,
  categorySlugById?: Map<number, string>,
): string {
  if (!categoryIds?.length || !categorySlugById) {
    return VENDOR_DIRECTORY_GENERIC_PLACEHOLDER;
  }
  const firstSlug = categorySlugById.get(categoryIds[0]);
  return getVendorCategoryPlaceholder(firstSlug);
}
